/**
 * A for-loop version of Array.prototype.find so IE and friends can play.
 *
 * @private
 * @param  {Array} arr
 * @param  {Function} predicate
 * @return {*|undefined}
 * @throws {TypeError} Argument predicate must be a function
 */
export default function find(
  arr: Array<any>,
  predicate: Function
): any | undefined {
  if (typeof predicate !== 'function') {
    throw new TypeError('predicate must be a function');
  }

  for (let i = 0; i < arr.length; i++) {
    if (predicate(arr[i], i, arr)) {
      return arr[i];
    }
  }

  return undefined;
}